import { render, staticRenderFns } from "./TdCost.vue?vue&type=template&id=1a775c2a&scoped=true&"
import script from "./TdCost.vue?vue&type=script&lang=js&"
export * from "./TdCost.vue?vue&type=script&lang=js&"
import style0 from "./TdCost.vue?vue&type=style&index=0&id=1a775c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a775c2a",
  null
  
)

export default component.exports